import React from 'react';
import { Link } from 'react-router-dom';
import './main.css';
import { FiHome, FiPackage } from 'react-icons/fi';
import { TbDashboard } from 'react-icons/tb';
import { MdOutlineDeliveryDining } from 'react-icons/md';
import { BiLogOutCircle } from 'react-icons/bi';
import { connect } from 'react-redux';
import { logout } from '../../../redux/actions/AuthActions';


const MenuItem = ({ logout }) => {

    const handleLogout = () => {
        logout()
    }


    return (
        <div className='mt-7 md:mt-0'>

            <div className='mb-3 '>
                <Link to='/' className="block py-2 px-4 hover:bg-gray-100">
                    <div className='flex items-center'>
                        <FiHome className='text-xl text-[#DC143C] mr-1' />
                        <p>Home</p>
                    </div>
                </Link>
            </div>

            <div className='mb-3'>
                <Link to='/artisan/dashboard' className="block py-2 px-4 hover:bg-gray-100">
                    <div className='flex items-center'>
                        <TbDashboard className='text-xl text-[#DC143C] mr-1' />
                        <p>Dashboard</p>
                    </div>
                </Link>
            </div>

            <div className='mb-3'>
                <Link to='/artisan/productList' className="block py-2 px-4 hover:bg-gray-100">
                    <div className='flex items-center'>
                        <FiPackage className='text-xl text-[#DC143C] mr-1' />
                        <p>Products</p>
                    </div>
                </Link>
            </div>

            <div className='mb-3'>
                <Link to='/artisan/orderList' className="block py-2 px-4 hover:bg-gray-100">
                    <div className='flex items-center'>
                        <MdOutlineDeliveryDining className='text-xl text-[#DC143C] mr-1' />
                        <p>Orders</p>
                    </div>
                </Link>
            </div>

            <div className='mb-3'>
                <div onClick={handleLogout} className=" cursor-pointer block py-2 px-4 hover:bg-gray-100">
                    <div className='flex items-center'>
                        <BiLogOutCircle className='text-xl text-[#DC143C] mr-1' />
                        <p>Logout</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default connect(null, { logout })(MenuItem);